class CursorFx {
    constructor(el) {
        this.DOM = {
            body: document.querySelector('body'),
            el
        };

        this.DOM.dot = this.DOM.el.querySelector('.dot');
        this.DOM.circle = this.DOM.el.querySelector('.circle');

        this.bounds = {
            dot: this.DOM.dot.getBoundingClientRect(),
            circle: this.DOM.circle.getBoundingClientRect()
        };

        this.scale = 1;
        this.opacity = 1;
        this.mousePos = {
            x: 0,
            y: 0
        };

        this.lastMousePos = {
            dot: {
                x: 0,
                y: 0
            },
            circle: {
                x: 0,
                y: 0
            }
        };
        this.lastScale = 1;
        this.lastOpacity = 1;

        this.initEvents();
        requestAnimationFrame(() => this.render());
    }

    initEvents() {
        window.addEventListener('mousemove', (ev) => {
            this.mousePos = this.getMousePos(ev);
        });

        window.addEventListener('mousedown', (ev) => {
            if (this.scale === 1.7) {
                this.leave();
            }
            else {
                this.enter();
            }
        });

        window.addEventListener('dragover', (ev) => {
            this.leave();
        });

        window.addEventListener('mouseup ', (ev) => {
            this.leave();
        });
    }

    render() {
        this.lastMousePos.dot.x = window.MathUtils.lerp(this.lastMousePos.dot.x, this.mousePos.x - this.bounds.dot.width / 2, 1);
        this.lastMousePos.dot.y = window.MathUtils.lerp(this.lastMousePos.dot.y, this.mousePos.y - this.bounds.dot.height / 2, 1);
        this.lastMousePos.circle.x = window.MathUtils.lerp(this.lastMousePos.circle.x, this.mousePos.x - this.bounds.circle.width / 2, 0.15);
        this.lastMousePos.circle.y = window.MathUtils.lerp(this.lastMousePos.circle.y, this.mousePos.y - this.bounds.circle.height / 2, 0.15);
        this.lastScale = window.MathUtils.lerp(this.lastScale, this.scale, 0.15);
        this.lastOpacity = window.MathUtils.lerp(this.lastOpacity, this.opacity, 0.1);
        this.DOM.dot.style.transform = `translateX(${(this.lastMousePos.dot.x)}px) translateY(${this.lastMousePos.dot.y}px)`;
        this.DOM.circle.style.transform = `translateX(${(this.lastMousePos.circle.x)}px) translateY(${this.lastMousePos.circle.y}px) scale(${this.lastScale})`;
        this.DOM.circle.style.opacity = this.lastOpacity;
        requestAnimationFrame(() => this.render());
    }

    enter() {
        this.scale = 1.7;
    }

    leave() {
        this.scale = 1;
    }

    click() {
        this.lastScale = 1;
        this.lastOpacity = 0;
    }

    getMousePos(e) {
        let posx = 0;
        let posy = 0;
        let ev = e;

        if (!e) {
            ev = window.event;
        }

        if (ev && (ev.pageX || ev.pageY )) {
            posx = ev.pageX;
            posy = ev.pageY;
        }
        else if (ev.clientX || ev.clientY) {
            posx = ev.clientX + this.body.scrollLeft + document.documentElement.scrollLeft;
            posy = ev.clientY + this.body.scrollTop + document.documentElement.scrollTop;
        }

        return { x: posx, y: posy };
    }
}
